export { default as Chart } from './Chart.vue'
export { default as FilterChart } from './FilterChart.vue'



// WEBPACK FOOTER //
// ./client/src/charts/index.js